export class DateTransformer {
  static transform(serverDate: string): Date {
    const newDate = new Date(serverDate);
    newDate.setTime(newDate.getTime() + newDate.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }
}
